import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import palette from '@src/theme/palette';
import { useState } from 'react';

interface Props {
	options: any[];
}

const TableOfContents = (props: Props) => {
	const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

	const renderStepText = (text: string) => {
		const sectionTitles = props.options.map((o: any, i: number) => ({ title: o.title as string, index: i }));
		const parts: React.ReactNode[] = [];
		let remaining = text;
		let keyIdx = 0;

		while (remaining.length > 0) {
			let earliest: { pos: number; title: string; sectionIndex: number } | null = null;
			for (const { title, index } of sectionTitles) {
				const pos = remaining.indexOf(title);
				if (pos !== -1 && (earliest === null || pos < earliest.pos)) {
					earliest = { pos, title, sectionIndex: index };
				}
			}

			if (!earliest) {
				parts.push(<span key={keyIdx++}>{remaining}</span>);
				break;
			}

			if (earliest.pos > 0) {
				parts.push(<span key={keyIdx++}>{remaining.slice(0, earliest.pos)}</span>);
			}

			const si = earliest.sectionIndex;
			parts.push(
				<span
					key={keyIdx++}
					onClick={() => setExpanded(si.toString())}
					style={{ color: "#2D60FF", cursor: "pointer", fontWeight: 600 }}
				>
					{earliest.title}
				</span>
			);

			remaining = remaining.slice(earliest.pos + earliest.title.length);
		}

		return parts;
	};

	const RenderItem = (section: any) => {
		switch(section.title){
			default: {
				let counter = 0;
				return (
					<AccordionDetails>
						<ol style={{ listStyle: "none", margin: 0, padding: 0 }}>
							{section.steps.map((step: string, stepIndex: number) => {
								const isSkip = step.startsWith("[skip]");
								const text = isSkip ? step.replace("[skip]", "") : step;
								if (!isSkip) counter++;
								return (
									<li key={stepIndex} style={{ display: "flex", gap: "8px", marginBottom: "6px" }}>
										{!isSkip && (
											<Typography fontSize={14} minWidth={20}>{counter}.</Typography>
										)}
										<Typography fontSize={14} sx={{ whiteSpace: "pre-wrap" }}>
											{renderStepText(text)}
										</Typography>
									</li>
								);
							})}
						</ol>
					</AccordionDetails>
				);
			}
		}
	}

	return (
    <Card sx={{
			width: "100%", height: "100%",
			px: {
				xl: "30px",
				lg: "30px",
				md: "10px",
				sm: "10px",
				xs: "10px",
			}, py: "15px", borderRadius: "25px" }}>
			{props.options.map((section: any, index: number) => {
				const active = expanded === index.toString();

				return (
					<Accordion key={index.toString()}
						expanded={active} onChange={handleChange(index.toString())}>
						<AccordionSummary
							expandIcon={active ? <RemoveOutlinedIcon sx={{ color: palette.blue["main"]}}/> : <AddOutlinedIcon sx={{ color: palette.blue["md-light"]}}/>}
							aria-controls="panel1-content"
							id="panel1-header"
						>
							<Typography
								fontFamily="Inter"
								fontWeight={700}
								color={active ? palette.blue.main : palette.blue["md-light"]} >{section.title}</Typography>
						</AccordionSummary>
						{RenderItem(section)}
					</Accordion>
				);
			})}
    </Card>
  );
}

export default TableOfContents
